export const initHomepageProfileResearchOptIn = () => {
    const dialogResearchOptIn = document.getElementById("dialog-research-opt-in");
    if (!dialogResearchOptIn) {
        return;
    }
    const hostnameBase = window.location.hostname.replace(/^[^.]*./, "");
    const closeDialogButtons = dialogResearchOptIn.querySelectorAll(".close-dialog");
    closeDialogButtons.forEach((closeDialogButton) => {
        closeDialogButton.addEventListener("click", () => {
            document.cookie =
                "research_opt_in=false; max-age=2592000; path=/; domain=" +
                    hostnameBase +
                    "; secure; samesite=lax";
        });
    });
};
